const axios = require('axios')

const demographicUrl = process.env.REACT_APP_HOST_API + '/demographic-survey'

export const checkDemographicSurvey = async (userId, sessionId) => {
  try {
    const res = await axios.get(`${demographicUrl}/check/${userId}/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error checking demographic survey:', error)
    throw error
  }
}

export const submitDemographicSurvey = async (userId, sessionId, responses) => {
  try {
    const res = await axios.post(`${demographicUrl}/submit`, {
      userId,
      sessionId,
      ...responses
    })
    return res.data
  } catch (error) {
    console.error('Error submitting demographic survey:', error)
    throw error
  }
}

export const getDemographicSurveysBySession = async (sessionId) => {
  try {
    const res = await axios.get(`${demographicUrl}/session/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error fetching demographic surveys:', error)
    throw error
  }
}